var map = {
	"./abc.avif": 6352,
	"./abc.png": 732,
	"./abc.webp": 3535,
	"./alka.avif": 2230,
	"./alka.png": 6620,
	"./alka.webp": 6194,
	"./almbrand.avif": 7033,
	"./almbrand.png": 8540,
	"./almbrand.webp": 3945,
	"./aros.avif": 742,
	"./aros.png": 2545,
	"./aros.webp": 6644,
	"./codan.avif": 545,
	"./codan.png": 316,
	"./codan.webp": 8348,
	"./coopforsikringer.avif": 5048,
	"./coopforsikringer.png": 2566,
	"./coopforsikringer.webp": 9514,
	"./dansk_boligforsikring.avif": 7380,
	"./dansk_boligforsikring.png": 3487,
	"./dansk_boligforsikring.webp": 342,
	"./dfa.avif": 3792,
	"./dfa.png": 7243,
	"./dfa.webp": 1204,
	"./ditforsikringshus.avif": 2538,
	"./ditforsikringshus.png": 666,
	"./ditforsikringshus.webp": 9645,
	"./fdm.svg": 9366,
	"./forsia.avif": 1818,
	"./forsia.png": 6461,
	"./forsia.webp": 2922,
	"./gfforsikring.avif": 9297,
	"./gfforsikring.png": 4304,
	"./gfforsikring.webp": 8351,
	"./gjensidige-min.avif": 6646,
	"./gjensidige-min.png": 3867,
	"./gjensidige-min.webp": 1118,
	"./gjensidige.avif": 2725,
	"./gjensidige.png": 9983,
	"./gjensidige.webp": 6487,
	"./global-min.avif": 8558,
	"./global-min.png": 3791,
	"./global-min.webp": 7600,
	"./global.avif": 9871,
	"./global.png": 1253,
	"./global.webp": 6965,
	"./if.svg": 947,
	"./ifforsikringsagentur.avif": 8810,
	"./ifforsikringsagentur.png": 4523,
	"./ifforsikringsagentur.webp": 1772,
	"./lokal.avif": 9332,
	"./lokal.png": 6831,
	"./lokal.webp": 8546,
	"./pensam.avif": 3335,
	"./pensam.png": 9605,
	"./pensam.webp": 1488,
	"./sonderjysk-cropped.avif": 4977,
	"./sonderjysk-cropped.png": 4296,
	"./sonderjysk-cropped.webp": 9379,
	"./sonderjysk.avif": 4268,
	"./sonderjysk.png": 5596,
	"./sonderjysk.webp": 8824,
	"./storstroems_forsikring.avif": 9491,
	"./storstroems_forsikring.png": 9895,
	"./storstroems_forsikring.svg": 2235,
	"./storstroems_forsikring.webp": 4650,
	"./topdanmark-logo-150-2021.avif": 3294,
	"./topdanmark-logo-150-2021.png": 5740,
	"./topdanmark-logo-150-2021.webp": 9700,
	"./topdanmark-min-org.avif": 2231,
	"./topdanmark-min-org.png": 3810,
	"./topdanmark-min-org.webp": 7685,
	"./topdanmark-min.avif": 3346,
	"./topdanmark-min.png": 6605,
	"./topdanmark-min.webp": 667,
	"./topdanmark.avif": 2200,
	"./topdanmark.png": 8169,
	"./topdanmark.webp": 848,
	"./tryg.avif": 9046,
	"./tryg.png": 8709,
	"./tryg.webp": 5466
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1097;